'use strict';
const strings = {

  format: function () {
    var s = arguments[0];
  /* DEBUG THIS*/
    for (var i = 0; i < arguments[1].length; i++) {
      var reg = new RegExp("\\{" + i + "\\}", "gm");
      s = s.replace(reg, arguments[1][i]);
    }
    
    return s;
  }
}

module.exports = strings;